<template>
	<input type="file" class="_file" name="file" :id="id" @change="change" :accept="Accept"	:multiple="Number(shuliang)>1" />
</template>

<script>
	
	const kuozhanming = {
		ac3: 'audio/ac3',
		asf: 'allpication/vnd.ms-asf',
		au: 'audio/basic',
		css: 'text/css',
		csv: 'text/csv',
		doc: 'application/msword',
		dot: 'application/msword',
		dtd: 'application/xml-dtd',
		dwg: 'image/vnd.dwg',
		dxf: 'image/vnd.dxf',
		gif: 'image/gif',
		htm: 'text/html',
		html: 'text/html',
		jp2: 'image/jp2',
		jpe: 'image/jpeg',
		jpeg: 'image/jpeg',
		jpg: 'image/jpeg',
		js: 'text/javascript, application/javascript',
		json: 'application/json',
		mp2: 'audio/mpeg, video/mpeg',
		mp3: 'audio/mpeg',
		mp4: 'audio/mp4,video/mp4',
		mpeg: 'video/mpeg',
		mpg: 'video/mpeg',
		mpp: 'application/vnd.ms-project',
		ogg: 'application/ogg, audio/ogg',
		pdf: 'application/pdf',
		png: 'image/png',
		pot: 'application/vnd.ms-powerpoint',
		pps: 'application/vnd.ms-powerpoint',
		ppt: 'application/vnd.ms-powerpoint',
		rtf: 'application/rtf, text/rtf',
		svf: 'image/vnd.svf',
		tif: 'image/tiff',
		tiff: 'image/tiff',
		txt: 'text/plain',
		wdb: 'application/vnd.ms-works',
		wps: 'application/vnd.ms-works',
		xhtml: 'application/xhtml+xml',
		xlc: 'application/vnd.ms-excel',
		xlm: 'application/vnd.ms-excel',
		xls: 'application/vnd.ms-excel',
		xlt: 'application/vnd.ms-excel',
		xlw: 'application/vnd.ms-excel',
		xml: 'text/xml, application/xml',
		zip: 'aplication/zip',
		xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
	}
	export default {
		data() {
			return {
				id: "_file",
				accept: {
					wenjian: ['zip', 'rar', 'xls', 'xlsx', 'doc', 'docx', 'pdf'],
					tu: ['jpg', 'png', 'gif', 'jpeg', 'webp'],
					yinpin: ['wma', 'wav', 'amr', 'mp4', 'mpeg'],
					yinyue: ['mp3', 'wma', 'wav', 'amr'],
					teshu: ['txt']
				},
				shu: {
					host: '',
					formData: {}
				},
			}
		},
		props: {
			leixing: {
				type: String,
				default: "wenjian"
			},
			chuanbendi: {
				type: Number,
				default: 0
			},
			shuliang: {
				type: [Number, String],
				default: 0
			}
		},
		mounted() {
			this.id += this.randomString(10)
		},
		computed: {
			Accept() {
				let a = ''
				for (let i in this.accept[this.leixing]) {
					a += kuozhanming[this.accept[this.leixing][i]] + ","
				}
				return a
			}
		},
		methods: {
			click() {
				document.getElementById(this.id).value = ''
				document.getElementById(this.id).click()
				this.$post('k=wenjian&c=oss', {
					chuanbendi: this.chuanbendi,
					leixing: this.leixing
				}, (s) => {
					if (s.shi == 1) {
						this.shu = s.shu //服务器签名			
					}
				})
			},
			change(e) {
				if (e.target.files.length > Number(this.shuliang) && Number(this.shuliang) > 0) {
					this.$emit('cuowu', '超出数量限制');
					return false
				}
				this.lie=[]
				this.Shangchuan(0,e.target.files)				
			},
			Shangchuan(i,targetFiles){
				if(i>=targetFiles.length){
					return this.Xingzeng()
				}
				let files =targetFiles[i]
				let data = new FormData();		
				let key= this.shu.dir + this.Wenjianming(files.name, this.shu.formData.key)
				this.shu.formData.key=key
				for (let i in this.shu.formData) data.append(i, this.shu.formData[i]); //服务器签名
				data.append('file', files);
				this.$axios.post(this.shu.host, data, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'kouling':this.shu.kouling
					},
					onUploadProgress: (e) => {
						let process = (e.loaded / e.total * 100 | 0)
						if(process==100)process=95
						this.$emit('jindu', process);
					}
				}).then(res => {					    
					let shu = {
						url: this.shu.url + "/" + key,
						ming: files.name.substring(0, files.name.lastIndexOf('.')),
						daxiao: files.size,
					}
					if (res.data.shi == 1) {
						shu.url = res.data.shu.url,
						shu.oss='bendi'
						this.$emit('chenggong', shu);
						this.lie[i]=shu
					} else if (this.shu.fuwushang == 'Aliyun' || this.shu.fuwushang == 'Qiniuyun') {
						shu.oss=this.shu.fuwushang
						this.$emit('chenggong', shu)
						this.lie[i]=shu
					}else{
						this.$emit('cuowu', res.data.shu)
					}
					this.$emit('jindu', 100)
					setTimeout((e)=>{
						this.Shangchuan(i+1,targetFiles)
					},10)
				}).catch(err => {						
					if(this.shu.fuwushang == 'Qiniuyun'){
						this.$emit('cuowu',err.response.data.error)
					}else if(this.shu.fuwushang == 'Aliyun'){
						let cuo=this.$x2js.xml2js(err.response.data)
						if(cuo.Error){
							this.$emit('cuowu', cuo.Error.Message)
						}
					}					
				})
			},
			Wenjianming(filename, ming) {
				let pos = filename.lastIndexOf('.');
				let suffix = '';
				if (pos != -1) {
					suffix = filename.substring(pos);
				}
				return this.$md5(ming + new Date().getTime() + Math.random().toString(36).substring(3, 20)) + suffix;
			},
			randomString(len) {
				len = len || 32;
				let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
				let maxPos = $chars.length;
				let pwd = '';
				for (let i = 0; i < len; i++) {
					pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
				}
				return pwd;
			},
			Xingzeng(){
				this.$post('k=wenjian&c=xinzeng',{leixing:this.leixing,lie:this.lie},(e)=>{})
			}
		}
	}
</script>
<style scoped="scoped">
	._file {
		opacity: 0;
		width: 0;
		height: 0;
		position: absolute;
		z-index: -1;
	}
</style>
